import { useOverlays } from "contexts/OverlayContext";
import { ManualBillCreationDrawer } from "./ManualBillCreationDrawer";

export const ManualBillCreationDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("manualBillCreation");

    if (!overlayInfo) {
        return null;
    }

    return (
        <ManualBillCreationDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            initialRows={overlayInfo.data?.initialRows}
        />
    );
};
